import { PageLocatorMap } from '../types/PageLocatorMap';

export const verificationDocumentListPage = {
  footer: {
    root: 'verification-document-list-page.footer.root',
  },
  form: {
    getVerificationLink: (index: number) =>
      `verification-document-list-page.form.verification-link-${index + 1}`,
    h1: 'verification-document-list-page.form.h1',
    h2: 'verification-document-list-page.form.h2',
    root: 'verification-document-list-page.form.root',
  },
  header: {
    drawerButton: 'verification-document-list-page.header.drawer-button',
    previousStepButton:
      'verification-document-list-page.header.previous-step-button',
    root: 'verification-document-list-page.header.root',
  },
  progress: {
    root: 'verification-document-list-page.progress.root',
  },
} as const satisfies PageLocatorMap;
